import { render, staticRenderFns } from "./fiestasorteo.vue?vue&type=template&id=3f879d54&"
import script from "./fiestasorteo.vue?vue&type=script&lang=js&"
export * from "./fiestasorteo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports